import type { State } from '../reducers';
import { useSelector as useReduxSelector } from 'react-redux';

/**
 * A (progressively) type safe redux selector function, useful for writing
 * components that are more type-safe.
 */
export function useSelector<T>(selector: (state: State) => T, equalityFn?: (left: T, right: T) => boolean) {
  return useReduxSelector<State, T>(selector, equalityFn);
}
